import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VueGtag from 'vue-gtag'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import Hotjar from 'vue-hotjar'

import store from './store'

import App from './App.vue'
import Button from './components/FloatingButton.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faQuestionCircle, faRuler, faUserCircle, faCamera } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.use(VeeValidate)
Vue.use(VueGtag, {
  config: { id: 'G-S5ZZ621C5L'}
});

Vue.use (Hotjar, {
  id: '3124954' // Hotjar Site ID
})

Vue.config.productionTip = false

library.add(faQuestionCircle, faRuler, faUserCircle, faCamera)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(FloatingVue)

const root = document.createElement('div')
document.body.appendChild(root)
new Vue({
  store,
  render: h => h(App)
}).$mount(root)

const insertAfter = ( elem, refElem) => refElem.parentNode
  .insertBefore(elem, refElem.nextSibling)
const buttonRoot = document.createElement('div')
// const el = document.querySelector(window.widgetConfig.el)
const el = document.querySelector('#vdr-size-widget')
insertAfter(buttonRoot, el)
new Vue({
  store,
  render: h => h(Button)
}).$mount(buttonRoot)